export const HEADER_NAV_HEIGHT = 72;

export const HEADER_NAV_MESSAGE_HEIGHT = 38;
export const HEADER_NAV_HEIGHT_WITH_MESSAGE =
  HEADER_NAV_HEIGHT + HEADER_NAV_MESSAGE_HEIGHT;
